import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import React, { useContext, useState } from 'react';
import { useIconProvider } from '@front10/utils';

interface Props {
  icon?: string;
  animation?: 'mirror' | 'infinite';
  size?: number;
  paths?: string[];
  viewBox?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
  fill?: string;
}

// TODO: Fix svgPaths
const renderPaths = (svgPaths: string[]) => {
  if (svgPaths.length !== 0) {
    return svgPaths.map((item: string, key: number) => <path key={key} d={item} />);
  }
  return null;
};

const renderSprite = (icon: string) => {
  return <use xlinkHref={`#${icon}`}></use>;
};

export type IconProps = StyledProps<Props>;

function Icon({
  icon = 'broken-heart',
  animation,
  size = 16,
  viewBox = '0 0 1024 1024',
  paths = [],
  fill = undefined,
  ...props
}: IconProps) {
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const [aniActive, setAnimationActive] = useState(false);
  let newViewBox = viewBox;
  let newIcon = icon;

  let enableSprite = false;
  let finalPath = paths;
  const { config, icons } = useIconProvider();
  if (icons && icons?.length > 0) {
    if (config && config.enableSprite) {
      enableSprite = true;
    }
    if (config && config.id) {
      newIcon = `${config.id}${icon}`;
    }
    const iconFound = icons.find((item: $TSFixMe) => item.icon === icon) as $TSFixMe;
    if (iconFound) {
      if (!config.enableSprite) {
        finalPath = iconFound.paths;
      }
      if (iconFound.viewBox) {
        newViewBox = iconFound.viewBox && iconFound.viewBox;
      }
    } else {
      console.warn(`Please add ${icon} to the iconsProvider. Searching and loading embedded icon.`);
    }
  }

  let classNameRotate = '';
  if (animation) {
    if (animation !== 'infinite' && aniActive) {
      classNameRotate = `fr-icon-animation-${animation}-active`;
    } else {
      classNameRotate = `fr-icon-animation-${animation}`;
    }
  }
  const rotateIcon = () => {
    setAnimationActive(!aniActive);
  };
  const classIcons = `fr-icon fr-icon-${icon} ${className} ${classNameRotate}`;
  return (
    <svg
      onClick={() => animation !== 'infinite' && rotateIcon()}
      className={classIcons}
      style={fill === undefined ? style : { ...style, fill: fill }}
      width={size}
      height={size}
      viewBox={newViewBox}
      aria-hidden={props.ariaHidden}
    >
      {enableSprite && renderSprite(newIcon)}
      {!enableSprite && renderPaths(finalPath)}
      {props.ariaLabel && <text className="fr-sr-only">{props.ariaLabel}</text>}
    </svg>
  );
}

Icon.defaultProps = {
  style: {
    // TODO: Setting by default the same color that bootstrap applies to the text content
    fill: 'currentColor'
  }
};

Icon.componentName = 'Icon';

export default Icon;
